/* eslint-disable @typescript-eslint/no-floating-promises */
import ApexCharts from 'apexcharts'
import { Flex } from '@chakra-ui/react'
import { useEffect } from 'react'
import { IDadoGrafico } from '../../../../PesquisaPercepcao/ResultadoIndividual'

interface BarChartProps {
  id: string
  series: IDadoGrafico[]
  labels: string[]
  notaMaximaEscala: number
  notaMinimaEscala: number
  stepSize: number
  onSetGrafico?: (blob: string) => void
}

export const BarChartAlternativo: React.FC<BarChartProps> = ({ id, labels, series, notaMaximaEscala, notaMinimaEscala, stepSize, onSetGrafico }) => {
  async function GerarGrafico(): Promise<void> {
    const options = {
      series: series.map(e => { return { data: e.medias.map(a => a.toFixed(2)), name: e.nome } }),
      scales: {
        r: {
          min: notaMinimaEscala,
          max: notaMaximaEscala,
          ticks: {
            min: 0,
            max: 10,
            stepSize: stepSize,
            font: {
              size: 10
            },
            z: 1
          }
        }
      },
      colors: [
        'rgb(0, 143, 251)',
        'rgb(0, 227, 150)',
        '#F2C94C',
        'rgb(255, 69, 96)',
        '#fe00f4',
        '#BB6BD9',
        '#219653',
        '#F2994A'
      ],
      chart: {
        type: 'bar',
        height: 320,
        width: 1000,
        animations: {
          enabled: false
        }
      },
      tooltip: {
        enabled: true,
        y: {
          formatter: (seriesName: any) => seriesName,
          title: {
            formatter: () => ''
          }
        }
      },
      grid: {
        show: false
      },
      plotOptions: {
        bar: {
          horizontal: true,
          dataLabels: {
            position: 'top'
          }
        }
      },
      dataLabels: {
        enabled: true,
        offsetX: -20
      },
      xaxis: {
        labels: {
          show: false
        },
        categories: labels,
        title: {
          style: {
            color: '#000',
            fontSize: '20px',
            fontWeight: 600
          }
        }
      }
    }
    const chart = new ApexCharts(document.querySelector(`#chart-${id}`), options)
    chart.render()

    const dataURL = await chart.dataURI().then((value: any) => {
      return value
    })

    if (onSetGrafico) {
      onSetGrafico(dataURL.imgURI)
    }
  }

  useEffect(() => {
    GerarGrafico()
  }, [])
  return (
      <Flex id={`chart-${id}`} />
  )
}
